/**
 * Carburants des vaisseaux (moteur / générateur / réservoir), du moins au plus
 * AVANCÉ. Un carburant plus avancé est plus DENSE (Resource.FuelEnergyDensity) :
 * à réservoir égal, il donne plus de PORTÉE (LY) et le générateur en produit plus
 * d'ÉNERGIE embarquée. C'est l'axe de progression « meilleur carburant ».
 *
 * NB : ne concerne QUE les carburants (cette chaîne) — les gemmes-éléments des
 * armes/boucliers (saphir, émeraude…) ne sont PAS des carburants (combat/RPS) et
 * renvoient `null` ici.
 */
export const FUEL_ORDER = ['petrole', 'uranium', 'deuterium', 'antimatiere'] as const;

export const FUEL_TIER_COUNT = FUEL_ORDER.length;

/** Rang du carburant (1 = pétrole … 4 = antimatière) ; null si ce n'est pas un
 *  carburant (gemme-élément de combat, ou code inconnu). */
export function fuelTier(code?: string | null): number | null {
  if (!code) return null;
  const i = FUEL_ORDER.indexOf(code as (typeof FUEL_ORDER)[number]);
  return i >= 0 ? i + 1 : null;
}

/** Le code désigne-t-il un carburant (vs une gemme-élément de combat) ? */
export function isFuel(code?: string | null): boolean {
  return fuelTier(code) !== null;
}

/** Aide contextuelle pour la ressource d'un composant : carburant (compatibilité +
 *  densité = portée/énergie) vs élément de combat (forces/faiblesses). */
export function resourceRoleHint(code?: string | null): string {
  return isFuel(code)
    ? 'Carburant : moteur, générateur et réservoir doivent utiliser le MÊME. '
      + 'Plus le carburant est avancé (pétrole → uranium → deutérium → antimatière), '
      + 'plus tu vas LOIN et plus le générateur produit d’ÉNERGIE — sans changer de réservoir.'
    : 'Élément de combat : détermine tes forces/faiblesses (cycle des éléments) ; '
      + 'doit correspondre à la cellule de gemme.';
}
